import { render } from "./TopChallenge.vue?vue&type=template&id=231e6c0c"
import script from "./TopChallenge.vue?vue&type=script&lang=ts"
export * from "./TopChallenge.vue?vue&type=script&lang=ts"

import "./TopChallenge.vue?vue&type=style&index=0&id=231e6c0c&lang=scss"
script.render = render

export default script